// extracted by mini-css-extract-plugin
export default {"Year":"Year_Year__HgVsU","Year_portfolio":"Year_Year_portfolio__EYcWE","Year__Letters":"Year_Year__Letters__v6Etm","Year__Letters_portfolio":"Year_Year__Letters_portfolio__3OFLv"};